/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import {
  Table,
  Tag,
  Button,
  Row,
  Col,
  Spin,
  Form,
  Input,
  Select,
  DatePicker,
  Typography,
  Divider,
} from "antd";

import "../../form.css";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import dayjs from "dayjs";
import { FormInstance } from "antd/lib/form";
import { RootState, RootDispatch } from "store";

const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const mapState = (state: RootState) => ({
  couponRecords: state.coupons.couponRecords,
  loading: state.loading.global,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  getCouponRecords: (data) => dispatch.coupons.getCouponRedcordsAsync(data),
  getCouponDetail: (data) => dispatch.coupons.getCouponDetailAsync(data),
});

type connectedProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;
type Props = connectedProps;

class CouponRecordList extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onFormFinish = this.onFormFinish.bind(this);
  }

  state = {
    currentPage: 1,
    pageSize: 10,
    details: null,
  };

  refFormRecords = React.createRef<FormInstance>();

  componentDidMount() {
    const { match } = this.props as { match?: any };
    const {
      params: { id },
    } = match;
    this.props.getCouponRecords({
      page: 1,
      row: this.state.pageSize,
      cid: id,
    });
    this.props.getCouponDetail({ id: id }).then((res: any) => {
      this.setState({
        details: res.data,
      });
    });
  }

  columns = [
    {
      title: "状态",
      dataIndex: "status",
      render: (text: any) => {
        if (text === "1") {
          return <Tag color="#2db7f5">已领取</Tag>;
        } else if (text === "2") {
          return <Tag color="#87d068">可使用</Tag>;
        } else if (text === "3") {
          return <Tag color="#faad14"> 已使用</Tag>;
        } else if (text === "4") {
          return <Tag color="#ff0000"> 已过期</Tag>;
        } else if (text === "5") {
          return <Tag color="#1890ff"> 已退还</Tag>;
        }
      },
    },
    {
      title: "用户",
      dataIndex: "user",
    },
    {
      title: "优惠券码",
      dataIndex: "coupon_number",
      render: (text: React.ReactDOM, record: any) => {
        return <div>{text}</div>;
      },
    },

    {
      title: "优惠券有效期",
      dataIndex: "start",
      render: (text: React.ReactDOM, record: any) => {
        return (
          <div>
            {dayjs.unix(record.start).format("YYYY-MM-DD")} 至
            {dayjs.unix(record.end).format("YYYY-MM-DD")}
          </div>
        );
      },
    },
    {
      title: "领取时间",
      dataIndex: "create_time",
      render: (text: any, record: any) => {
        return <div>{dayjs.unix(text).format("YYYY-MM-DD HH:mm")}</div>;
      },
    },
    {
      title: "使用时间",
      dataIndex: "use_time",
      render: (text: any, record: any) => {
        return (
          <div>
            {text === "0" ? null : dayjs.unix(text).format("YYYY-MM-DD HH:mm")}
          </div>
        );
      },
    },
    {
      title: "订单编号",
      dataIndex: "item_number",
    },
    // {
    //   title: "操作",
    //   dataIndex: "id",
    //   render: (text: React.ReactDOM, record: any) => {
    //     return (
    //       <Button onClick={this.showDetailWindow.bind(this, { record })}>
    //         查看
    //       </Button>
    //     );
    //   },
    // },
  ];

  onPaginationChange(page, pageSize) {
    const { match } = this.props as { match?: any };
    const {
      params: { id },
    } = match;
    this.setState({
      currentPage: page,
    });
    const values = this.refFormRecords.current.getFieldsValue();
    const _values = this.rangePickerFormatter(values);
    this.props.getCouponRecords({
      ..._values,
      page: page,
      row: pageSize,
      cid: id,
      status: _values.status === "全部" ? null : _values.status,
    });
  }

  onFormFinish(values) {
    const { match } = this.props as { match?: any };
    const {
      params: { id },
    } = match;
    this.setState({
      currentPage: 1,
    });
    const _values = this.rangePickerFormatter(values);
    // console.log(_values);
    this.props.getCouponRecords({
      ..._values,
      page: 1,
      row: this.state.pageSize,
      cid: id,
      status: _values.status === "全部" ? null : _values.status,
    });
  }

  rangePickerFormatter(values) {
    let _values;
    if (Array.isArray(values.coupon_start_time)) {
      const coupon_start_time = values.coupon_start_time[0].format(
        "YYYY-MM-DD"
      );
      const coupon_end_time = values.coupon_start_time[1].format("YYYY-MM-DD");
      _values = Object.assign(values, { coupon_start_time, coupon_end_time });
    }

    if (Array.isArray(values.start_time)) {
      const start_time = values.start_time[0].format("YYYY-MM-DD");
      const end_time = values.start_time[1].format("YYYY-MM-DD");
      _values = Object.assign(values, { start_time, end_time });
    }

    if (Array.isArray(values.use_start_time)) {
      const use_start_time = values.use_start_time[0].format("YYYY-MM-DD");
      const use_end_time = values.use_start_time[1].format("YYYY-MM-DD");
      _values = Object.assign(values, { use_start_time, use_end_time });
    }
    return Object.assign({}, _values, values);
  }

  render() {
    const dateFormat = "YYYY-MM-DD";
    const rangeStyle = {};
    const { couponRecords, loading } = this.props;
    const { pageSize, details } = this.state;
    // console.log(couponRecords);
    // const { list, total } = couponRecords;
    return (
      <div>
        <div>
          {details && (
            <div className="page-title">
              <Title level={3}>{details.name}</Title>
              <div>ID:{details.id}</div>
              <div>面额： ￥{details.quota}</div>
              <div>适用品类: {details.category_name}</div>
              <div>库存: {details.stock}</div>
              <div>已领取: {details.receive}</div>
            </div>
          )}
          <Divider />
          <Form
            onFinish={this.onFormFinish}
            layout="inline"
            ref={this.refFormRecords}
          >
            <Row gutter={[18, 24]}>
              <Col>
                <Form.Item
                  name="coupon_start_time"
                  label="有效期"
                  style={rangeStyle}
                >
                  <RangePicker format={dateFormat} />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item
                  name="start_time"
                  label="领取时间"
                  style={rangeStyle}
                >
                  <RangePicker format={dateFormat} />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item
                  name="use_start_time"
                  label="使用时间"
                  style={rangeStyle}
                >
                  <RangePicker format={dateFormat} />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item name="name">
                  <Input
                    allowClear
                    placeholder="请输入用户名、订单编号、优惠券券码等关键词"
                    style={{ width: 350 }}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item name="status" initialValue={"全部"} label="状态">
                  <Select style={{ minWidth: 100 }}>
                    <Option value={undefined}>全部</Option>
                    <Option value="1">已领取</Option>
                    <Option value="2">可使用</Option>
                    <Option value="3">已使用</Option>
                    <Option value="4">已过期</Option>
                    <Option value="5">已退还</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col>
                <Button type="primary" htmlType="submit">
                  <SearchOutlined />
                  搜索
                </Button>
              </Col>
              <Col>
                <Button
                  type="default"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  <ReloadOutlined />
                  重置
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
        <Spin tip="Loading..." size="large" spinning={loading}>
          <Table
            columns={this.columns}
            dataSource={couponRecords.list}
            rowKey={"id"}
            pagination={{
              total: couponRecords.total,
              pageSize: pageSize,
              current: this.state.currentPage,
              position: ["bottomCenter"],
              onChange: this.onPaginationChange,
            }}
          />
        </Spin>

        {/* <Modal
          title={this.state.detailWindow.title}
          visible={this.state.detailWindow.visiable}
          onOk={this.cancelDetailWindow}
          onCancel={this.cancelDetailWindow}
        >
          <div>
            {"id" in this.state.currentData && this.state.currentData.id}
          </div>
        </Modal> */}
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(CouponRecordList);
